export default __webpack_public_path__ + "static/media/digital-store-product-01.83fe39d6.jpg";